<template>
  <nav class=""><!--col-md-2 d-none d-md-block bg-light sidebar-->
    <div > <!--class="sidebar-sticky"-->
      <ul class="nav grid-navigation-container">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>

        </slot>
      </ul>
    </div>
  </nav>
</template>
<script>
  import SidebarLink from './SidebarLink.vue'

  export default {
    components: {
      SidebarLink
    },
    props: {
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    }
  }

</script>
<style>
</style>
